
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  components: {}
})
export default class RegidEdit extends Vue {
  @Prop({}) editNameParam!: {};
  formData: any;
  rules = {
    name: [{ required: true, message: "请输入面试名称", trigger: "change" }]
  };

  created() {
    this.formData = this.editNameParam;
  }

  editCancel() {
    this.$emit("close", false);
  }
  editOk() {
    (this.$refs["form"] as any)?.validate((valid: any) => {
      if (valid) {
        this.$emit("ok", this.formData);
      } else {
        //
      }
    });
  }
}
